export const PAYMENT_METHOD_NAME = 'woo-2checkout';
